import React, { Component } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import image from '../images/venky.png'
import { autocompleteClasses, Button, Icon, IconButton } from '@mui/material';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';
import resumeshot from '../images/resumeshot.png';
import Modal from '@mui/material/Modal';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import Typed from 'react-typed';
import CustomButton from '../shared/CustomButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import resume from '../images/resume1.pdf';

const style = {
    bgcolor: 'background.paper',
    width : 600,
    justifySelf : 'center',
    boxShadow: 24,
    margin : 4,
    padding : 4,
  };
function Home(){
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);  
    const handleClick = ()=>{
        fetch('../images/resume1.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Venkatesh_Resume.pdf';
                alink.click();
            })
        })
    }
    return (
        <Box sx={{ lineHeight: 30, justifyContent : 'center'}} id='Home'>
        <Grid container sx={{ display: 'flex', flexDirection : 'column', alignItems : 'start'}}>
            <Stack direction='column' spacing={2}>
                <CustomButton>
                <Typography variant='h6'>Hi, my name is </Typography>
                </CustomButton>
                		
                <Typography variant='h2' className='text-white' sx={{fontFamily:'Crimson Text, serif',}}>
					<Typed
                    strings={['Venkatesh Patnala']}
                    typeSpeed={30}
					 cursorChar=""  
                />
				</Typography>
                <Typography variant='h4' className='text-white'>I build websites - Full Stack Developer</Typography>
                <Typography variant='h6' className='text-white'>{` Armed with expertise in Reactjs, Nextjs, and CSS, Nodejs I specialize in leading teams to deliver innovative solutions. Explore my journey through the world of software development, where each line of code is a step towards creating meaningful and impactful applications.`}</Typography>
                {/* <Typography variant='h6'><b> Mail me: </b><a href="mailto:patnala.1@alumni.iitj.ac.in" style={{textDecoration : 'none', color:'#3da8f5'}}> patnala.1@alumni.iitj.ac.in</a> , <a href="mailto:venkateshjnv123@gmail.com" style={{textDecoration : 'none', color:'#3da8f5'}}> venkateshjnv123@gmail.com</a></Typography>  */}
                
            </Stack>   
            <Button className="w-fit h-fit my-2 p-2 px-4 text-white rounded-t-full rounded-br-full cursor-auto bg-[#56CCF2]"
             onClick={handleOpen}>Resume<CloudDownloadIcon/></Button>
            <Modal
        open={open}
        onClose={handleClose}
        sx={{overflow : 'scroll',margin: 'auto', justifyContent: 'flex-end', alignItems:'center'}}
    >
        <center>
         <Box sx={style}>
		{/*	<IconButton sx={{justifySelf : 'flex-end'}} onClick={handleClose}>
            <CloseIcon color='error'/>
          </IconButton> */}
        {/* 
        <Document file={resume}>
                <Page pageNumber={1} scale={1} />
               </Document>  */}
			   <iframe title="PDF Viewer" src={resume} width="100%" height="500px"></iframe>
			   <div style={{alignSelf : 'flex-end'}}>
  <Button color='primary' variant='contained' onClick={handleClick} sx={{margin :'12px'}}>download</Button>
			   <Button color='secondary' variant='contained' onClick={handleClose} sx={{margin :'12px'}}>Close</Button>
			   </div>
             
               </Box>  
               </center>
      </Modal>
    
      {/* <Button color='primary' sx={{padding:'2', width:'200px'}} onClick={handleOpen}>Resume</Button>
    <Modal
        open={open}
        onClose={handleClose}
        sx={{overflow : 'scroll',margin: 'auto', justifyContent: 'center', alignItems:'center'}}
    >
        <center>
       
        <Box sx={style}>
        <IconButton sx={{position:'relative' , top: 0, left: 250}} onClick={handleClose}>
            <CloseIcon color='error'/>
            <Typography>Close</Typography>
          </IconButton>
        <Document file={resume}>
                <Page pageNumber={1} scale={1} />
               </Document> 
               <Button color='secondary' variant='contained' onClick={handleClick}>download</Button>
               </Box>  
               </center>
      </Modal> */}
      {/* <Stack direction="row" spacing={2}>
     <IconButton size='large' href='https://mui.com/material-ui/react-button/#icon-button'>
      <InstagramIcon fontSize='large'/>
     </IconButton>
     <IconButton>
      <LinkedInIcon fontSize='large' />
     </IconButton>
<IconButton>
  <GitHubIcon fontSize='large'/>
</IconButton>

        </Stack> */}
                {/* <img src={require('../images/venky.png')} alt='venky' height="200" width ='200' /> */}
            </Grid>
            {/* <Grid xs={6} md={3} item sx={{display : 'flex', flexDirection : 'column'}}>
            

               
               {/* <Document file={resume}>
                <Page pageNumber={1} scale={1} width="300" />
               </Document>
               <img src={resumeshot} onClick={handleOpen} alt='Resume Image' width="100%" height="100%" />
    <Modal
        open={open}
        onClose={handleClose}
        sx={{overflow : 'scroll',justifyContent :'center', alignItems :'center'}}
    >
        
        <Box sx={style}>
        <Button onClick={handleClick}>download</Button>
        <Document file={resume}>
                <Page pageNumber={1} scale={1} />
               </Document> 
               </Box>  
      </Modal>
              
            </Grid> */}
        </Box>
      
    )
}

export default Home;